import React from 'react';
import { useState } from 'react';
import PartnerTile from '../components/PartnerTile';
import MercedesImage from '../images/MercedesBenz.svg';
import HomeDepotImage from '../images/HomeDepot.svg';
import HolcimImage from '../images/Holcim.svg';
import ToyotaImage from '../images/Toyota.svg';
import OlamImage from '../images/Olam.svg';
import YamaichiImage from '../images/Yamaichi.svg';
import '../App.css';
import {
  Link,
  FlexLayout,
  TextLabel,
  Paragraph,
  Title
} from '@nutanix-ui/prism-reactjs';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';

export default function MobilePartners() {





return (
  <FlexLayout className="partners" itemSpacing="20px" flexDirection="column">

       <Title className="sectionTitle">Don’t just take our word for it</Title>
       <Paragraph className="sectionDescription">Here is what customers and stakeholders are saying about our work. </Paragraph>

       <Carousel
          partialVisible={true}
          showDots={true}
          swipeable={true}
          draggable={true}
          ssr={true}
          keyBoardControl={true}
          itemClass="partnerItems"
          containerClass="partnersCarousel"
      removeArrowOnDeviceType={["tablet", "mobile"]}
      renderDotsOutside={true}
      dotListClass="articleCarouselDots"
        responsive={{
          desktop: {
            breakpoint: {
              max: 3000,
              min: 1024
            },
            items: 3,
            partialVisibilityGutter: 40
          },
          mobile: {
            breakpoint: {
              max: 464,
              min: 0
            },
            items: 1,
            partialVisibilityGutter: 60
          },
          tablet: {
            breakpoint: {
              max: 1024,
              min: 464
            },
            items: 1
          }
        }}

        deviceType="mobile"
      >
      <div className="partnersTile"><PartnerTile image={HomeDepotImage} name="The Home Depot" position="Customer" company="Prism Pro" value="Prism Pro makes it extremely easy to watch all of the clusters in our environment and quickly reconfigure things as needed. It provides very clear metrics on oversubscription and utilization, giving us a powerful, proactive capacity management function that we never had before."/></div>
      <div className="partnersTile"><PartnerTile image={MercedesImage} name="Mercedes-Benz [LATM]" position="Customer" value="As soon as we were introduced to Nutanix, we thought, ‘Well, there’s an interesting solution that we need to test internally. We could see that the environment—not only the applications, but also the infrastructure—was well developed and offered the simplicity and everything else we needed."/></div>
      <div className="partnersTile"><PartnerTile image={YamaichiImage} name="Yamaichi Special Steel" position="Customer" company="NDB" value="Thanks to the ease of use of the GUI, we can easily deal with various operations, starting with daily operation checks, detecting errors in weekend coverage, checking NDB, etc. It was my first time using Nutanix, but their engineers helped by giving me detailed instructions."/></div>
      <div className="partnersTile"><PartnerTile image={MercedesImage} name="Mercedes-Benz [LATM]" position="Customer"  value="With Nutanix, I don’t need those separate teams. One person can operate the whole environment on their own. The operation is easy and the interface is very user-friendly, so one team member can handle a cluster with three or one hundred nodes without much effort."/></div>
      <div className="partnersTile"><PartnerTile image={HolcimImage} name="Holcim Group [EMEA]" position="Customer"  value="One of the key advantages is simplicity, since we manage all the clusters from a single console, and we are capable of automating critical activities such as loading security patches. Another great benefit we have experienced is scalability. In any relevant multinational company, the possibility of dynamically cope with the demand based on business needs has unquestionable value."/></div>
      <div className="partnersTile"><PartnerTile image={ToyotaImage} name="Toyota Motor Corporation" position="Customer" value="We also highly valued the fact that it enabled us to start small, expand ﬂexibly, and respond promptly to changes in the business environment; as a result, we decided to adopt the Nutanix Cloud Platform."/></div>
      <div className="partnersTile"><PartnerTile image={OlamImage} name="Olam" position="Customer" company="Prism Pro" value="It simplifies the entire process, be it a software or firmware upgrade, while the Prism Pro console allows you to manage your entire IT footprint through a single interface."/></div>

</Carousel>

  </FlexLayout>
);


}
